/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NSABaseServer } from "namirasoft-account";
import { NamirasoftJobArrangerServerCompany } from "./NamirasoftJobArrangerServerCompany";
import { NamirasoftJobArrangerServerError } from "./NamirasoftJobArrangerServerError";
import { NamirasoftJobArrangerServerExtensionChromeSetting } from "./NamirasoftJobArrangerServerExtensionChromeSetting";
import { NamirasoftJobArrangerServerHealthz } from "./NamirasoftJobArrangerServerHealthz";
import { NamirasoftJobArrangerServerJob } from "./NamirasoftJobArrangerServerJob";
import { NamirasoftJobArrangerServerJobCategory } from "./NamirasoftJobArrangerServerJobCategory";
import { NamirasoftJobArrangerServerJobField } from "./NamirasoftJobArrangerServerJobField";
import { NamirasoftJobArrangerServerJobTag } from "./NamirasoftJobArrangerServerJobTag";
import { NamirasoftJobArrangerServerLocation } from "./NamirasoftJobArrangerServerLocation";
import { NamirasoftJobArrangerServerReason } from "./NamirasoftJobArrangerServerReason";
import { NamirasoftJobArrangerServerReasonCategory } from "./NamirasoftJobArrangerServerReasonCategory";
import { NamirasoftJobArrangerServerReasonField } from "./NamirasoftJobArrangerServerReasonField";
import { NamirasoftJobArrangerServerReasonTag } from "./NamirasoftJobArrangerServerReasonTag";
import { NamirasoftJobArrangerServerRemote } from "./NamirasoftJobArrangerServerRemote";
import { NamirasoftJobArrangerServerUser } from "./NamirasoftJobArrangerServerUser";
import { NamirasoftJobArrangerServerValue } from "./NamirasoftJobArrangerServerValue";
import { TokenManager } from "namirasoft-account";

export class NamirasoftJobArrangerServer extends NSABaseServer
{
    healthz: NamirasoftJobArrangerServerHealthz;
    value: NamirasoftJobArrangerServerValue;
    company: NamirasoftJobArrangerServerCompany;
    job_category: NamirasoftJobArrangerServerJobCategory;
    job_field: NamirasoftJobArrangerServerJobField;
    job_tag: NamirasoftJobArrangerServerJobTag;
    job: NamirasoftJobArrangerServerJob;
    location: NamirasoftJobArrangerServerLocation;
    reason_category: NamirasoftJobArrangerServerReasonCategory;
    reason_field: NamirasoftJobArrangerServerReasonField;
    reason_tag: NamirasoftJobArrangerServerReasonTag;
    reason: NamirasoftJobArrangerServerReason;
    remote: NamirasoftJobArrangerServerRemote;
    user: NamirasoftJobArrangerServerUser;
    error: NamirasoftJobArrangerServerError;
    extension_chrome_setting: NamirasoftJobArrangerServerExtensionChromeSetting;
    constructor(base_url: string, manager: TokenManager, onError: (error: Error) => void)
    {
        super(base_url, `1.4.54`, manager, onError);
        this.healthz = new NamirasoftJobArrangerServerHealthz(this);
        this.value = new NamirasoftJobArrangerServerValue(this);
        this.company = new NamirasoftJobArrangerServerCompany(this);
        this.job_category = new NamirasoftJobArrangerServerJobCategory(this);
        this.job_field = new NamirasoftJobArrangerServerJobField(this);
        this.job_tag = new NamirasoftJobArrangerServerJobTag(this);
        this.job = new NamirasoftJobArrangerServerJob(this);
        this.location = new NamirasoftJobArrangerServerLocation(this);
        this.reason_category = new NamirasoftJobArrangerServerReasonCategory(this);
        this.reason_field = new NamirasoftJobArrangerServerReasonField(this);
        this.reason_tag = new NamirasoftJobArrangerServerReasonTag(this);
        this.reason = new NamirasoftJobArrangerServerReason(this);
        this.remote = new NamirasoftJobArrangerServerRemote(this);
        this.user = new NamirasoftJobArrangerServerUser(this);
        this.error = new NamirasoftJobArrangerServerError(this);
        this.extension_chrome_setting = new NamirasoftJobArrangerServerExtensionChromeSetting(this);
    }
};